import { render, staticRenderFns } from "./StatsButton.vue?vue&type=template&id=5e980a06"
import script from "./StatsButton.vue?vue&type=script&lang=js"
export * from "./StatsButton.vue?vue&type=script&lang=js"
import style0 from "./StatsButton.vue?vue&type=style&index=0&id=5e980a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports